import {Component, Input, ElementRef, ViewChild, OnInit, OnChanges, SimpleChanges, AfterViewInit} from '@angular/core';
import {ElementCoordinates} from '../test/test';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {image} from 'html2canvas/dist/types/css/types/image';

@Component({
  selector: 'app-tuto',
  imports: [
    MatIconButton,
    MatIcon
  ],
  standalone: true,
  templateUrl: './tuto.html',
  styleUrl: './tuto.css',
})
export class Tuto implements AfterViewInit {
  @ViewChild('textContainer') textContainer!: ElementRef;

  left=200
  top=100
  width=100
  height=100

  @Input() ids=""
  @Input() autostart=0
  @Input() step=0
  @Input() text_to_show="text"
  @Input() colorEffect=""
  @Input() small=false
  old_style:any
  image=""

  getCenter(elementId: string) : any {
    const rc=this.getElementCoordinates(elementId)
    return {
      top:rc.top+rc.height/2,
      left:rc.left+rc.width/2,
      width: rc.width*1.5,
      height:rc.height*2
    }
  }


  /**
   * Get pixel coordinates of an element by its id
   * @param elementId - The id of the element to get coordinates for
   * @returns ElementCoordinates object with pixel positions, or null if element not found
   */
  getElementCoordinates(elementId: string): ElementCoordinates  {
    console.log('[Tuto DEBUG] getElementCoordinates called with elementId:', elementId, 'type:', typeof elementId);
    if (!elementId) {
      console.error('[Tuto DEBUG] ERROR: elementId is undefined or null in getElementCoordinates!');
    }
    if(elementId && elementId.indexOf("/")>-1){
      elementId=elementId.substring(elementId.indexOf("/")+1);
    }
    const element = document.getElementById(elementId);
    if (!element) {
      return {
        x: 0,
        y:0,
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
    }
    const rect = element.getBoundingClientRect();
    return {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left
    };
  }


  print_step(idx=1){
    const idsArray = this.ids ? this.ids.split("|") : [];
    if(idx<idsArray.length){
      const elementId = idsArray[idx-1];
      if (!elementId) {
        console.error('[Tuto DEBUG] ERROR: elementId is undefined! idx:', idx, 'idsArray length:', idsArray.length);
      }
      let rc=this.getCenter(elementId)
      this.left=rc.left
      this.top=rc.top
      this.width=rc.width
      this.height=rc.height
      const key=this.ids.split("|")[this.step - 1]
      if(key && key.toLowerCase().endsWith(".jpg")){
        this.image="./"+key
      }else{
        this.image=""
        if(this.colorEffect!=""){
          const element = document.getElementById(key);
          this.old_style=element?.style
          element?.setAttribute("style",element?.style+";color:"+this.colorEffect)

          setTimeout(()=>{
            element?.setAttribute("style",this.old_style)
          },2000)

        }
      }
    }
  }

  protected close_tuto() {
    this.step=0
  }

  protected next_step() {
    this.step=this.step+1
    const idsArray = this.ids ? this.ids.split("|") : [];
    console.log('[Tuto DEBUG] after increment, step:', this.step, 'idsArray length:', idsArray.length);
    if(this.step>idsArray.length){
      console.log('[Tuto DEBUG] step exceeds array length, resetting to 0');
      this.step=0
      if(this.autostart>0){
        //Il ne faut pas répéter le tuto sur le poste
      }
    }
    if(this.step>0){
      localStorage.setItem(this.ids,"started")
    }
    console.log('[Tuto DEBUG] calling print_step with idx:', this.step);
    this.print_step(this.step)
  }



  get currentText(): string {
    const elementId = this.ids.split("|")[this.step - 1];
    if (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        return element.attributes.getNamedItem("title")?.value || '';
      }
    }
    return '';
  }


  protected start_tuto() {
    this.step=1
    this.print_step(this.step)
  }

  ngAfterViewInit(): void {
    if(this.autostart>0 && !localStorage.getItem(this.ids)){
      setTimeout(()=>{
        this.start_tuto()
      },this.autostart*1000)
    }
  }

}
